import { ReportingPeriodDICTItem } from 'src/pages/SignInPage/_BLL/types';

// Converts null to number in reporting reportingPeriodId (Current period).
export const periodNullToValue = (reportingPeriodId: number | null, reportingPeriodsDICT: ReportingPeriodDICTItem[]) => {
	return reportingPeriodId === null ? (reportingPeriodsDICT[0]?.id as number) : reportingPeriodId;
};
